var isCart = $(".cart").length ? true : false;
var isSet = $(".set-items").length ? true : false;
var currency = $(".site-currency").val();

var currencyInfo = {
    siteCurrency : currency == "MXN" ? "MXN" : "GTQ",
    siteLocale : currency == "MXN" ? "es-MX" : "es-GT",
}


/**
 * clear large and width inputs
 * @param {Object} thisEl - Element jquery edited
 */
function clearLargeWidthField(thisEl) {
    var calculator = $(thisEl).closest('.calculator');
    calculator.find(".js-large-meters").val("");
    calculator.find(".js-width-meters").val("");
}

/**
 * Set M2 total in label Total
 * @param {Object} thisEl - Element jquery edited
 * @param {string} m2Val - m2 value
 */
function setTotalM2(thisEl, m2Val) {
    var calculator = $(thisEl).closest('.calculator');
    calculator.find(".value-m2").html(m2Val);
}

/**
 * Get total cost aprox of boxes
 * @param {Object} thisEl - Element jquery edited
 * @param {string} CantidadProd - num of boxes
 */
function getTotalAprox(thisEl, CantidadProd) {
    var calculator = $(thisEl).closest('.calculator');
    var totalInfo = calculator.find(".total-info");
    var price = totalInfo.attr('data-price');
    var totalPrice = price * CantidadProd;

    var cantidadFormateada = parseFloat(totalPrice).toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN'
    });

    totalInfo.html(cantidadFormateada);
}

/**
 * Calculate meters quantity
 * @param {Object} thisEl - Element jquery edited
 */
function calcularMetros(thisEl) {
    if (window.isBlockSale) {
        return;
    }
    var productDetail = $(thisEl).closest('.product-detail');
    var calculator = $(thisEl).closest('.calculator');
    var metrosCaja =  calculator.find('.metrosCaja');
    var dispExistenciasN = calculator.find('.dispExistenciasN');
    var dispExistencias = calculator.find('.dispExistencias');
    var addToCart= productDetail.find('.add-to-cart');
    var metrosCajaDnVal = parseFloat(calculator.find('.metrosCajaDn').val());
    var cantidadProdVal = parseFloat(calculator.find('.CantidadProd').val());
    var cantidadDisVal = parseFloat(calculator.find('.cantidadDis').val());

    if (Number.isNaN(metrosCajaDnVal) && Number.isNaN(cantidadProdVal)) {
        metrosCaja.val('');
    } else {
        var totalMetros = cantidadProdVal * metrosCajaDnVal;
        metrosCaja.val(totalMetros.toFixed(2));

        var disableAddToCart = cantidadProdVal > cantidadDisVal;
        dispExistenciasN.toggle(disableAddToCart);
        dispExistencias.toggle(!disableAddToCart);
        addToCart.prop('disabled', disableAddToCart);
        if (disableAddToCart) {
            addToCart.removeClass("btn-outline-primary").addClass("btn-primary");
        } else {
            addToCart.removeClass("btn-primary").addClass("btn-outline-primary");
        }
    }
}

/**
 * Calculate boxes quantity
 * @param {Object} thisEl - Element jquery edited
 */
function calcularCajas(thisEl) {
    var productDetail = $(thisEl).closest('.product-detail');
    var calculator = $(thisEl).closest('.calculator');
    var metrosCaja = parseFloat(calculator.find('.metrosCaja').val());
    var metrosCajaDn = parseFloat(calculator.find('.metrosCajaDn').val());
    var cantidadProdInput = calculator.find('.CantidadProd');
    var cantidadDisInput = calculator.find('.cantidadDis');
    var dispExistenciasN = calculator.find('.dispExistenciasN');
    var dispExistencias = calculator.find('.dispExistencias');
    var addToCartBtn = productDetail.find('.add-to-cart');

    if (Number.isNaN(metrosCaja)) {
        cantidadProdInput.val('');
        return;
    }

    var cantidadProd = Math.ceil(metrosCaja / metrosCajaDn);
    cantidadProdInput.val(cantidadProd);

    if (cantidadProd > parseFloat(cantidadDisInput.val())) {
        dispExistenciasN.show();
        dispExistencias.hide();
        addToCartBtn.prop('disabled', true).removeClass("btn-outline-primary").addClass("btn-primary");
    } else {
        dispExistenciasN.hide();
        dispExistencias.show();
        addToCartBtn.prop('disabled', false).removeClass("btn-primary").addClass("btn-outline-primary");
    }
}


/**
 * Set M2 total in label Total
 * @param {Object} thisEl - Element jquery edited
 * @param {string} largeVal - m2 value
 * @param {string} widthVal - m2 value
 */
function calculateM2(thisEl, largeVal, widthVal) {
    if (largeVal > 0 && widthVal >0) {
        var calculator = $(thisEl).closest('.calculator');
        var m2 = largeVal * widthVal;
        m2 = m2 % 1 !== 0 ? m2.toFixed(2) : m2;
        calculator.find(".metrosCaja").val(m2).trigger('keyup');
        calculator.find(".value-m2").html(m2);
        calculator.find(".CantidadProd").trigger('change');
        var totalBoxes = calculator.find(".CantidadProd").val();

        getTotalAprox(thisEl, totalBoxes);
    }
}

/**
 * Set grand total price for product set
 * @param {Object} thisEl - Element jquery edited
 * @param {string} docReady - Set true only when document is loaded
 */
function setGrandTotalProductSet() {
    var priceSetItem = $(".total-wrapper-price-item");
    var grandTotal = 0;
    $.each(priceSetItem, function (i, el) {
        var totalPrice = $(el).attr("data-total-price");
        grandTotal += parseFloat(totalPrice);
    });

    var priceFormatted = parseFloat(grandTotal).toLocaleString(currencyInfo.siteLocale, {
        style: 'currency',
        currency: currencyInfo.siteCurrency
    });

    $(".grand-total-prod-set").html(priceFormatted + " " + currencyInfo.siteCurrency);
}

/**
 * Set total price for product item in product set
 * @param {Object} thisEl - Element jquery edited
 */
function setTotalProductSet(thisEl) {
    var price = parseFloat($(thisEl).attr("data-price"));
    var cantidadProd = $(thisEl).closest('.set-item').find(".CantidadProd").val();
    var quantity = cantidadProd;
    var totalPrice = price * quantity;

    var priceFormatted = parseFloat(totalPrice).toLocaleString(currencyInfo.siteLocale, {
        style: 'currency',
        currency: currencyInfo.siteCurrency
    });

    $(thisEl).html(priceFormatted).attr("data-total-price", totalPrice);

    // update and set grand total for product set
    setGrandTotalProductSet();
}

$(window).on('load',function () {
    if (!isCart && !isSet) {
        var CantidadProd = $(".CantidadProd");

        // in case there is more than one calculators in same page
        $.each(CantidadProd, function (i, el) {
            var cantProd = $(el).val();

            getTotalAprox(el, cantProd);
        });
    }

    if (isSet) {
        // update and format total price per item in product set
        var priceSetItem = $(".total-wrapper-price-item");
        $.each(priceSetItem, function (i, el) {
            setTotalProductSet(el, true);
        });
    }
});

$(document).on('keyup', '.metrosCaja', function () {
    var val = $(this).val();
    if (val !== "" && val > 0) {
        var calculator = $(this).closest('.calculator');

        calcularCajas(this);

        // Set Total m2 value in label        
        setTotalM2(this, val)

        calculator.find(".CantidadProd").trigger('change');

        // Set cajas value in label
        if (!isCart && !isSet) {
            var totalBoxes = calculator.find(".CantidadProd").val();
            getTotalAprox(this, totalBoxes);
        }

        if (isSet) {
            var element = $(this).closest('.set-item').find(".total-wrapper-price-item");
            setTotalProductSet(element);
        }
    }
});

// Set M2 value in label and set defaul m2 if value is empty or 0
$(document).on('change', '.metrosCaja', function () {
    var val = $(this).val();

    if (val === "" || val == 0) {
        var defaultValue = $(this).attr("data-metros-caja");

        setTotalM2(this, defaultValue)

        $(this).val(defaultValue).trigger("keyup");
    }
});

$(document).on('input', '.CantidadProd', function () {
    var thisEl = $(this);
    this.value = thisEl.val().replace(/[^0-9]/g, "");

    if (this.value === "0") {
        this.value = "1";
    }
    
    if (this.value !== "" && this.value > 0) {
        var calculator = $(this).closest('.calculator');
        calcularMetros(this);

        var m2Val = calculator.find('.metrosCaja').val();
        setTotalM2(this, m2Val);

        calculator.find(".total-boxes").html(this.value);
        getTotalAprox(this, this.value);

        if (isSet) {
            var element = $(this).closest('.set-item').find(".total-wrapper-price-item");
            setTotalProductSet(element);
        }
    }
});

$(document).on('change', '.CantidadProd', function (e) {
    var calculator = $(this).closest('.calculator');

    if (this.value === "") {
        this.value = "1";
        calculator.find(".total-boxes").html("1");
        $(this).trigger("input");
    }  else {
        calculator.find(".total-boxes").html(this.value);
    }
});

$(document).on('input', '.onlyNumbers', function () {
    // Remove other characters
    $(this).val($(this).val().replace(/[^0-9.]/g, ''));

    var valor = $(this).val();

    // validate if number has only to decimals
    if(valor.match(/^\d*\.?\d{0,2}$/) === null) {
        // if format is not correct delete last character
        $(this).val(valor.slice(0, -1));
    }
});

$(document).on('input', '.onlyEntireNumbers', function () {
    $(this).val($(this).val().replace(/[^0-9]/g, ''));
});

$(document).on('input', '.metrosCaja, .CantidadProd', function () {
    clearLargeWidthField(this);
});

$(document).on('input', '.js-large-meters, .js-width-meters', function () {
    var calculator = $(this).closest('.calculator');
    var largeVal = calculator.find(".js-large-meters").val();
    var widthVal = calculator.find(".js-width-meters").val();

    calculateM2(this, largeVal, widthVal);
});
